/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * other-sliders.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * ページ別
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * WAREHOUSE - 倉庫事業について
 * 
 */
if (window.document.body.classList.contains("warehouse") || window.document.body.classList.contains("building")) {

  const option__businessList = {
    loop: false,
    slidesPerView: "auto",
    initialSlide: 0,
    preventClicks: true,
    centeredSlides: false,
    grabCursor: true,
    navigation: {
      prevEl: '.business-list-tool-box .button__prev',
      nextEl: '.business-list-tool-box .button__next',
    },
    scrollbar: {
      el: '.business-list-scrollbar',
      hide: false,
      draggable: true
    }
  };

  const businessList = new Swiper(".business-list-slider", option__businessList);
}